import { getTextColor } from '../utils';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';

interface FileInstructionsProps {
  instructions: string[];
  readOnly?: boolean;
  title?: string;
}

export const FileInstructions = ({
  instructions,
  readOnly = false,
  title = 'File Requirements:',
}: FileInstructionsProps) => {
  return (
    <Box sx={{ mt: 2, width: '100%' }}>
      <Typography
        variant="subtitle2"
        color={getTextColor(readOnly, 'disabled')}
        gutterBottom
        sx={{ textAlign: 'center', fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
      >
        {title}
      </Typography>
      <List dense sx={{ px: { xs: 1, sm: 2 } }}>
        {instructions.map((instruction, index) => (
          <ListItem key={index} sx={{ py: 0 }}>
            <ListItemText
              primary={instruction}
              primaryTypographyProps={{
                variant: 'body2',
                color: getTextColor(readOnly, 'disabled'),
                sx: { fontSize: { xs: '0.7rem', sm: '0.75rem' } },
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
